<div class="credits-container" [class.low-balance]="isLowBalance">
  <!-- <div class="credits-display" (click)="onCreditsClick()">
    <span class="credits-value clickable" [ngClass]="{'active': isCreditPage}">{{ displayCredits }} Credits</span>
    <span><mat-icon class="arrow-down">keyboard_arrow_down</mat-icon></span>
  </div> -->
  <button class="credits-btn d-flex align-items-center cursor-pointer gap-2" (click)="onCreditsClick()">
    <span class="dot-live" aria-hidden="true"></span>

    <div class="credits-inner d-flex flex-column gap-1 align-items-start">
      <span class="credits-label">Credits</span>
      <span class="credits-value">{{ displayCredits | number }}</span>
    </div>

    <span class="redirect-arrow" aria-hidden="true">
      <img src="https://d2z9497xp8xb12.cloudfront.net/prod-images/908594c1777025213343right-arrow.png" width="12"
        height="12" alt="">
    </span>
  </button>

  <!-- <button class="upgrade-btn" (click)="onUpgradeClick(null)">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="sparkle-icon">
      <path
        d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
    </svg>
    <span style="font-size: 13px; font-weight: 500;">Upgrade</span>
  </button> -->
</div>